export enum NHLTeam {
    ANAHEIM_DUCKS = "ANA Ducks",
    ARIZONA_COYOTES = "ARI Coyotes",
    BOSTON_BRUINS = "BOS Bruins",
    BUFFALO_SABRES = "BUF Sabres",
    CALGARY_FLAMES = "CGY Flames",
    CAROLINA_HURRICANES = "CAR Hurricanes",
    CHICAGO_BLACKHAWKS = "CHI Blackhawks",
    COLORADO_AVALANCHE = "COL Avalanche",
    COLUMBUS_BLUE_JACKETS = "CBJ Blue Jackets",
    DALLAS_STARS = "DAL Stars",
    DETROIT_RED_WINGS = "DET Red Wings",
    EDMONTON_OILERS = "EDM Oilers",
    FLORIDA_PANTHERS = "FLA Panthers",
    LOS_ANGELES_KINGS = "LA Kings",
    MINNESOTA_WILD = "MIN Wild",
    MONTREAL_CANADIENS = "MTL Canadiens",
    NASHVILLE_PREDATORS = "NSH Predators",
    NEW_JERSEY_DEVILS = "NJ Devils",
    NEW_YORK_ISLANDERS = "NY Islanders",
    NEW_YORK_RANGERS = "NY Rangers",
    OTTAWA_SENATORS = "OTT Senators",
    PHILADELPHIA_FLYERS = "PHI Flyers",
    PITTSBURGH_PENGUINS = "PIT Penguins",
    ST_LOUIS_BLUES = "STL Blues",
    SAN_JOSE_SHARKS = "SJ Sharks",
    SEATTLE_KRAKEN = "SEA Kraken",
    TAMPA_BAY_LIGHTNING = "TB Lightning",
    TORONTO_MAPLE_LEAFS = "TOR Maple Leafs",
    VANCOUVER_CANUCKS = "VAN Canucks",
    VEGAS_GOLDEN_KNIGHTS = "VGS Golden Knights",
    WASHINGTON_CAPITALS = "WSH Capitals",
    WINNIPEG_JETS = "WPG Jets",
}

export enum NHLTeamColour {
    ANAHEIM_DUCKS = "#F47A38",
    ARIZONA_COYOTES = "#8C2633",
    BOSTON_BRUINS = "#FFB81C",
    BUFFALO_SABRES = "#002654",
    CALGARY_FLAMES = "#C8102E",
    CAROLINA_HURRICANES = "#CC0000",
    CHICAGO_BLACKHAWKS = "#CF0A2C",
    COLORADO_AVALANCHE = "#6F263D",
    COLUMBUS_BLUE_JACKETS = "#002654",
    DALLAS_STARS = "#006847",
    DETROIT_RED_WINGS = "#CE1126",
    EDMONTON_OILERS = "#041E42",
    FLORIDA_PANTHERS = "#041E42",
    LOS_ANGELES_KINGS = "#111111",
    MINNESOTA_WILD = "#154734",
    MONTREAL_CANADIENS = "#AF1E2D",
    NASHVILLE_PREDATORS = "#FFB81C",
    NEW_JERSEY_DEVILS = "#CE1126",
    NEW_YORK_ISLANDERS = "#00539B",
    NEW_YORK_RANGERS = "#0038A8",
    OTTAWA_SENATORS = "#C52032",
    PHILADELPHIA_FLYERS = "#F74902",
    PITTSBURGH_PENGUINS = "#000000",
    ST_LOUIS_BLUES = "#002F87",
    SAN_JOSE_SHARKS = "#006D75",
    SEATTLE_KRAKEN = "#001628",
    TAMPA_BAY_LIGHTNING = "#002868",
    TORONTO_MAPLE_LEAFS = "#00205B",
    VANCOUVER_CANUCKS = "#00205B",
    VEGAS_GOLDEN_KNIGHTS = "#B4975A",
    WASHINGTON_CAPITALS = "#041E42",
    WINNIPEG_JETS = "#041E42",
}
